
import React from 'react'
import ProdAbout from '../components/information/ProdAbout';
export default function About() {
  return <ProdAbout/>
}